import { render, staticRenderFns } from "./TrialStatusMatchingIcon.vue?vue&type=template&id=9a6a7eba&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports